import React, { useRef, useEffect, useState } from 'react';
//import { useNavigate } from 'react-router';
import styles from './styles.module.scss';
import Logo from '../../logos/logo_web_secondary.png';

export default function Header({ links }) {
  const [isOpen, setIsOpen] = useState(false);
  const toggleMenu = () => setIsOpen(v => !v);

  const innerRef = useRef(null);
  const [outerH, setOuterH] = useState(0);

  useEffect(() => {
    if (!innerRef.current) return;
    setOuterH(isOpen ? innerRef.current.scrollHeight : 0);
  }, [isOpen]);

//   const redirectToPlaylists = () => {
//     window.location.href = "/playlists";
//   };

  //  const navigate = useNavigate();

  // const redirect = (href) => {
  //   navigate(href);
  // };

  const scrollToSection = (id) => {
  const el = document.getElementById(id);
  if (el) {
    const y = el.getBoundingClientRect().top + window.scrollY - 80; // 80px offset
    window.scrollTo({ top: y, behavior: 'smooth' });
  }
};

  return (
    <div className={styles.header}>
      <div className={`${styles.panel} reg-round p-3 col-11 col-lg-6 mt-3`}>
        {/* Topplinje: logo venstre, burger høyre */}
        <div className={styles.topbar}>
          <div className={styles.leftCol} onClick={() => scrollToSection('top')}>
            <img className="img-fluid col-8" src={Logo} alt="Logo" />
          </div>

          <button
            type="button"
            className={styles.buttonContainer}
            onClick={toggleMenu}
            aria-expanded={isOpen}
            aria-controls="main-links"
          >
            <div className={`${styles.menuIcon} ${isOpen ? styles.open : ''}`}>
              <span></span><span></span><span></span>
            </div>
          </button>
        </div>

        {/* Kollaps-delen: bor i samme panel */}
        <div
          id="main-links"
          className={`${styles.linksOuter} ${isOpen ? styles.open : ''}`}
          style={{ height: outerH }}
        >
          <div ref={innerRef} className={styles.linksInner}>
            {links.map(l => (
              <div key={l.href} className={styles.link} onClick={() => scrollToSection(l.href)}>
                {l.label}
              </div>
            ))}
            {/* flere linker her */}
          </div>
        </div>
      </div>
    </div>
  );
}
